import { registerLocaleData } from '@angular/common';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * This service loads and registers the so called localeData
 * we use for date information renders (Mo, Di, Mi / Mo, Tu, We).
 * It provides the loadInitialLocaleData that is used as a APP_INITIALIZER,
 * and an awaitable registerLocale for the language switcher to switch after data is available
 */
@Injectable({
  providedIn: 'root'
})
export class LocaleLoaderService {
  constructor(private translateService: TranslateService) {}

  loadInitialLocaleData(): Promise<void> {
    const currentLang = this.translateService.currentLang || 'en';
    return this.registerLocale(currentLang);
  }

  async registerLocale(lang: string): Promise<void> {
    const localeMap = {
      de: () => import(`@angular/common/locales/de`).then(m => m.default),
      fr: () => import(`@angular/common/locales/fr`).then(m => m.default),
      it: () => import(`@angular/common/locales/it`).then(m => m.default),
      nl: () => import(`@angular/common/locales/nl`).then(m => m.default),
      es: () => import(`@angular/common/locales/es`).then(m => m.default),
      cs: () => import(`@angular/common/locales/cs`).then(m => m.default),
      sk: () => import(`@angular/common/locales/sk`).then(m => m.default),
      da: () => import(`@angular/common/locales/da`).then(m => m.default),
      pl: () => import(`@angular/common/locales/pl`).then(m => m.default),
      en: () => import(`@angular/common/locales/en`).then(m => m.default)
      // Add more locales as needed
    };

    // Check if the language is supported and import the locale data
    if (localeMap[lang]) {
      const localeData = await localeMap[lang]();
      registerLocaleData(localeData);
    }
  }
}
